import styled, { useTheme } from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../common/responsive';
import { hapticsImpactLight } from '../../common/haptic';
import GiftIcon from '../../assets/icons/wallet-gift.svg?react';
import SwapIcon from '../../assets/icons/wallet-swap.svg?react';
import SendIcon from '../../assets/icons/wallet-send.svg?react';
import ReceiveIcon from '../../assets/icons/wallet-receive.svg?react';
import SpendIcon from '../../assets/icons/card.svg?react';

const CircleContainer = styled.div`
  border-radius: 16px;
  background-color: ${({ theme, primary }) =>
    primary ? theme.primary.primary : theme.primary.background};
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.border.primary};
  @media (hover: hover) {
    &:hover {
      border: 1px solid ${({ theme }) => theme.primary.light};
      background-color: ${({ theme, primary }) =>
        primary ? theme.primary.lighter : theme.primary.light};
    }
  }
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 16px;
  padding-right: 16px;
  width: 100px;
  @media (min-width: ${({ theme }) => theme.breakpoints?.phone || '768px'}) {
    width: 130px;
  }
  @media ${PHONE_MEDIA_QUERY} {
    padding-left: unset;
    width: 100%;
    padding-right: unset;
  }

  display: flex;
`;

const CircleText = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.text.regular};
  @media ${PHONE_MEDIA_QUERY} {
    margin-top: 6px;
    font-size: 10px;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-between;
  max-width: 330px;
  @media (min-width: ${({ theme }) => theme.breakpoints?.phone || '768px'}) {
    min-width: 300px;
    max-width: 400px;
  }
  @media ${PHONE_MEDIA_QUERY} {
    max-width: 100%;
  }
`;

const CircleButton = ({
  onClick,
  imageUrl,
  primary,
  text,
  IconComponent,
  iconColor,
}) => {
  const theme = useTheme();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: theme.text.regular,
        width: '100%',
      }}
    >
      <CircleContainer onClick={onClick} primary={primary}>
        {IconComponent ? (
          <IconComponent
            width={24}
            height={24}
            style={{
              color:
                iconColor ||
                (primary ? theme.text.primary : theme.text.regular),
            }}
          />
        ) : (
          <img src={imageUrl} width={24} height={24} />
        )}
        {text && (
          <CircleText
            style={{
              color: primary ? 'white' : theme.text.regular,
            }}
          >
            {text}
          </CircleText>
        )}
      </CircleContainer>
    </div>
  );
};

const TokenActions = ({
  onGiftClick,
  onTradeClick,
  onSpendClick,
  onSendClick,
  onReceiveClick,
}) => {
  return (
    <ButtonsContainer>
      <CircleButton
        primary
        onClick={() => {
          hapticsImpactLight();
          onGiftClick();
        }}
        IconComponent={GiftIcon}
        text='Send Gift'
      />
      {onSpendClick && (
        <CircleButton
          onClick={() => {
            hapticsImpactLight();
            onSpendClick();
          }}
          IconComponent={SpendIcon}
          text='Spend'
        />
      )}
      <CircleButton
        onClick={() => {
          hapticsImpactLight();
          onTradeClick();
        }}
        IconComponent={SwapIcon}
        text='Trade'
      />
      <CircleButton
        onClick={() => {
          hapticsImpactLight();
          onReceiveClick();
        }}
        IconComponent={ReceiveIcon}
        text='Deposit'
      />
      <CircleButton
        onClick={() => {
          hapticsImpactLight();
          onSendClick();
        }}
        IconComponent={SendIcon}
        text='Withdraw'
      />
    </ButtonsContainer>
  );
};

export default TokenActions;
